var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHearts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 130 130",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1109"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style1107"
  }, ".cls-1{fill:none;stroke:currentColor;stroke-miterlimit:10;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lift"
  })), /*#__PURE__*/React.createElement("circle", {
    r: 33.933514,
    cy: 64.985474,
    cx: 65.157509,
    id: "path909",
    style: {
      opacity: 1,
      vectorEffect: "none",
      fill: "none",
      fillOpacity: 1,
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 56.517578,50.623047 c -5.735087,0.05587 -10.357593,4.715821 -10.367187,10.451172 -0.0095,5.780874 9.08237,14.251834 9.08237,14.251834 0,0 8.936993,8.875823 10.06224,8.951468 1.125246,0.07564 10.724631,-9.706396 10.724631,-9.706396 0,0 8.240838,-7.678161 8.251852,-13.459797 0.01056,-5.782398 -4.668773,-10.478344 -10.451172,-10.488281 -3.431986,-0.0055 -6.648729,1.671469 -8.609374,4.488281 -1.953546,-2.806616 -5.154658,-4.482277 -8.574219,-4.488281 -0.03971,-2.26e-4 -0.07943,-2.26e-4 -0.119141,0 z",
    style: {
      opacity: 1,
      vectorEffect: "none",
      fill: "none",
      fillOpacity: 1,
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    id: "path911"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHearts);
export default __webpack_public_path__ + "static/media/hearts.b00766b135abbc26d515dbead60b8972.svg";
export { ForwardRef as ReactComponent };